var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.6C24 15.2 22.8 15.6 21.4 15.8C20.5 14.1 18.7 12.8 16.6 11.9C16.8 11.6 17 11.4 17.2 11.1H18C21.1 11 24 12.9 24 14.6ZM6.8 11H6C2.9 11 0 12.9 0 14.6C0 15.2 1.2 15.6 2.6 15.8C3.5 14.1 5.3 12.8 7.4 11.9L6.8 11ZM12 12C14.2 12 16 10.2 16 8C16 5.8 14.2 4 12 4C9.8 4 8 5.8 8 8C8 10.2 9.8 12 12 12ZM12 13C7.9 13 4 15.6 4 18C4 20 12 20 12 20C12 20 20 20 20 18C20 15.6 16.1 13 12 13ZM17.7 10H18C19.7 10 21 8.7 21 7C21 5.3 19.7 4 18 4C17.5 4 17.1 4.1 16.7 4.3C17.5 5.3 18 6.6 18 8C18 8.7 17.9 9.4 17.7 10ZM6 10H6.3C6.1 9.4 6 8.7 6 8C6 6.6 6.5 5.3 7.3 4.3C6.9 4.1 6.5 4 6 4C4.3 4 3 5.3 3 7C3 8.7 4.3 10 6 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleUsers);
export default __webpack_public_path__ + "static/media/multiple-users.156ead6dc0a1a205d12312dc78e1f6c7.svg";
export { ForwardRef as ReactComponent };